import React, { useState } from 'react';
import { useAbsolutePath } from '../../../data/seo/seoRouteUtils';
import { classIf, getConfiguration, getEncodedURI, iconSportCssClass } from '../../../data/utils';
import MenuCountryItem from './MenuCountryItem';

function MenuSportItem(props) {
    const [isCollapsed, setIsCollapsed] = useState(initCollapsed());
    const conf = getConfiguration();

    function initCollapsed() {
        return props.menuLiveTogglers&&props.menuLiveTogglers.selectedSports.includes(props.id);
    }

    function handleClickLive(id, e) {
        props.menuLiveTogglers.toggleSport(id);
        setIsCollapsed(prev => !prev);
        e.stopPropagation();
    }

    function handleClickHref(url, e) {
        e.preventDefault();
    }

    const absoluteSportPath = useAbsolutePath(`${props.urlPath}${props.urlPathSuffix}`, null, props.urlPathSeo);    
   
    const icoSport = iconSportCssClass(props.id, props.iconClass);
    return (
        <div className={`card elemento-competizioni-widget sport-color-${props.id}`}>
            <div className={"titolo-accordion maiuscolo bianco d-flex d-centro-v pointer toggle-nascondi-live tog-menu" + classIf(isCollapsed, 'collapsed')} data-toggle="collapse" id={`sport-${props.id}`} data-parent="#accordionLaterale" href={`#menu-sport-${props.id}`} onClick={handleClickLive.bind(this, props.id)}>
                <a /*href={getEncodedURI(absoluteSportPath)}*/ className="d-flex d-centro-v maiuscolo grassetto" onClick={handleClickHref.bind(this,absoluteSportPath)}>
                    <div className={`icona-sport img-fluid margine-dx-mezzo ico-sport ${icoSport}`}></div>
                    {props.descrizione}
                </a>
                <span>{conf.iwh ? `(${props.eventsCount})` : props.eventsCount}</span>
            </div>
            <div id={`menu-sport-${props.id}`} className={"competzioni-sub margine-su-mezzo collapse" + classIf(!isCollapsed, 'show')} role="tabpanel" aria-labelledby={`sport-${props.id}`}>
                {props.categories.map(c =>
                    <MenuCountryItem key={c.id} {...c} sportId={c.sportRef} currentFilter={props.currentFilter} menuLiveTogglers={props.menuLiveTogglers} />
                )}
            </div>
        </div>
    );
}
    
export default MenuSportItem;